import { Font, StyleSheet } from '@react-pdf/renderer';

// @ts-ignore
import HeeboFontMedium from '../../assets/Heebo-Medium.ttf';
// @ts-ignore
import HeeboFont from '../../assets/Heebo-Regular.ttf';

export const RATE_TABLE_FROM_WIDTH = 40;
export const RATE_TABLE_TO_WIDTH = 40;
export const RATE_TABLE_RATE_WIDTH = 50;

Font.register({
    family: 'PdfFont',
    fonts: [{ src: HeeboFont }, { src: HeeboFontMedium }]
});

export const BASE_FONT_SIZE = 9;
export const PDF_PRIMARY_COLOR = '#0B4585';
const pdfStyles = StyleSheet.create({
    page: {
        fontSize: BASE_FONT_SIZE,
        padding: '100 0 30',
        fontFamily: 'PdfFont'
    },
    section: {
        display: 'flex',
        margin: '0 10'
    },
    padding0_10: {
        padding: '0 10'
    },
    paddingBottom10: {
        paddingBottom: '10px'
    },
    header: {
        display: 'flex',
        flexDirection: 'row'
    },
    spaceBetween: {
        justifyContent: 'space-between'
    },
    flexGrow1: {
        flexGrow: 1
    },
    alignCenter: {
        alignItems: 'center'
    },
    minWidth30percent: {
        minWidth: '30%'
    },
    minWidth200px: {
        minWidth: '200px'
    },
    flexRowBetween: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between'
    },
    flexRow: {
        display: 'flex',
        flexDirection: 'row'
    },
    paddingLeft10: {
        paddingLeft: 10
    },
    paddingRight20: {
        paddingRight: 20
    },
    paddingRight40: {
        paddingRight: 40
    },
    alignItemsFlexEnd: {
        alignItems: 'flex-end'
    },
    button: {
        padding: '2 0',
        width: 80,
        textAlign: 'center',
        color: 'white',
        backgroundColor: 'black',
        borderRadius: '4px',
        fontSize: BASE_FONT_SIZE - 1
    },
    littleText: {
        fontSize: BASE_FONT_SIZE - 2
    },
    margin2_10: {
        margin: '2 10'
    },
    marginBottom4px: {
        marginBottom: '4px'
    },
    marginBottom10px: {
        marginBottom: '10px'
    },
    paymentStatus: {
        fontSize: BASE_FONT_SIZE * 5 - 1,
        fontWeight: 'bold',
        color: 'gray'
    },
    marginTopMinus24BottomMinus14: {
        margin: '-24 0 -14 0'
    },
    mainDetails: {
        border: `1.2px solid ${PDF_PRIMARY_COLOR}`,
        borderRadius: 4,
        width: '60%',
        textAlign: 'center',
        marginBottom: 20,
        overflow: 'hidden'
    },
    mainDetailsTop: {
        backgroundColor: PDF_PRIMARY_COLOR,
        color: '#ffffff',
        fontWeight: 'bold',
        fontSize: BASE_FONT_SIZE + 4,
        padding: '7 0'
    },
    mainDetailsBottom: {
        backgroundColor: '#edf2f7',
        fontSize: BASE_FONT_SIZE + 2,
        padding: '5 0',
        fontWeight: 'bold',
        color: PDF_PRIMARY_COLOR
    },
    fontSizePlus2: {
        fontSize: BASE_FONT_SIZE + 2
    },
    fontSizePlus1: {
        fontSize: BASE_FONT_SIZE + 1
    },
    border: {
        border: '1px solid #2d3748'
    },
    borderBottom: {
        borderBottom: '1px solid #2d3748'
    },
    borderRed2px: {
        border: '2px solid red'
    },
    borderLight: {
        border: '1px solid gray'
    },
    padding4px: {
        padding: '4px'
    },
    padding0_4px_4px: {
        padding: '0 4px 4px'
    },
    padding2px4px: {
        padding: '2px 4px'
    },
    padding0_2px_4px_0: {
        padding: '0 2px 4px 0'
    },
    padding4_0: {
        padding: '4 0'
    },
    padding0_4: {
        padding: '0 4'
    },
    borderTop: {
        borderTop: '1px solid black'
    },
    width100: {
        width: '100%'
    },
    fontBoldAndBig2: {
        fontWeight: 'bold',
        fontSize: BASE_FONT_SIZE + 2
    },
    fontBoldAndBig1: {
        fontWeight: 'bold',
        fontSize: BASE_FONT_SIZE + 1
    },
    fontBold: {
        fontWeight: 'bold'
    },
    padding3_0: {
        padding: '3 0'
    },
    padding2_0: {
        padding: '2 0'
    },
    padding0: {
        padding: '0'
    },
    paddingLeft10px: {
        paddingLeft: '10px'
    },
    paddingTop10: {
        paddingTop: '10px'
    },
    rateTableWidth: {
        width: `${RATE_TABLE_FROM_WIDTH + RATE_TABLE_TO_WIDTH + RATE_TABLE_RATE_WIDTH}px`
    },
    width40Percent: {
        width: '40%'
    }
});

export default pdfStyles;
